import React from 'react';
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
interface ParcelDescriptionFieldProps {
  description: string;
  onDescriptionChange: (description: string) => void;
}
const ParcelDescriptionField: React.FC<ParcelDescriptionFieldProps> = ({
  description,
  onDescriptionChange
}) => {
  return <div className="space-y-2">
      <Label>Description of Contents (Optional)</Label>
      <Textarea value={description} onChange={e => onDescriptionChange(e.target.value)} placeholder="Please describe the contents of your parcel" className="min-h-[80px]" />
    </div>;
};
export default ParcelDescriptionField;